import { Fragment } from "react";

import ProfileSectionRow from "@/components/home/sections/components/ProfileSectionRow";
import ProfileWorkExperienceItem from "@/components/home/sections/components/ProfileWorkExperienceItem";
import type { ISectionProps } from "@/components/home/sections/ProfileBioSection";
import ProfileSectionCard from "@/components/home/sections/ProfileSectionCard";
import { DatePeriodSegment } from "@/components/ui/DatePeriodSegment";
import { ItemSectionDivider } from "@/components/ui/ItemSectionDivider";
import type { CommonModels } from "@/data/common/common.models";
import { ProfileUtils } from "@/util/profile.utils";

interface IProps extends ISectionProps {
  education?: CommonModels.EducationDto[];
}

const ProfileEducationSection = ({
  education,
  onEditSectionClicked,
  isPublic = false,
  enableInViewAnimation,
}: IProps) => {
  const filteredEducation = education?.filter((item) => {
    const isPeriodEmpty = !item.period?.start_date?.trim() && !item.period?.end_date?.trim();
    if (!item.institution_name?.trim() && isPeriodEmpty) {
      return false;
    }
    return true;
  });

  return (
    <ProfileSectionCard
      title="Education"
      isEmpty={!filteredEducation || filteredEducation.length === 0}
      onEditSectionClicked={onEditSectionClicked}
      isPublic={isPublic}
      enableInViewAnimation={enableInViewAnimation}
    >
      <div className="mt-6 flex flex-col gap-6">
        {filteredEducation?.map((item, index) => (
          // oxlint-disable-next-line react/no-array-index-key
          <Fragment key={index}>
            <ProfileSectionRow
              title={item?.institution_name || "Unknown"}
              subTitle={
                <DatePeriodSegment
                  period={item.period}
                  className="text-text-default-3"
                />
              }
              index={index}
              sectionId="education"
              hasAdditionalInfo={
                !!item.field_of_study || !!item.degree || !!item.grade || !!item.location.city || !!item.description
              }
            >
              <ProfileWorkExperienceItem
                value={item.field_of_study}
                segment="Field of Study"
              />
              <ProfileWorkExperienceItem
                value={item.degree}
                segment="Degree"
              />
              <ProfileWorkExperienceItem
                value={item.grade?.toString() || null}
                segment="Grade"
              />
              <ProfileWorkExperienceItem
                value={ProfileUtils.getDisplayAddress(item.location)}
                segment="Location"
              />
              <ProfileWorkExperienceItem
                value={item.description}
                segment="Description"
              />
            </ProfileSectionRow>
            {index !== filteredEducation.length - 1 && <ItemSectionDivider />}
          </Fragment>
        ))}
      </div>
    </ProfileSectionCard>
  );
};

export default ProfileEducationSection;
